import RequestFormPagingResultModelBase from '../_generated/modelBases/request-form-paging-result-model-base';

export default class RequestFormPagingResultModel extends RequestFormPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
